/**
 * Replaces `{key}` placeholders in `template` with string values from `vars`.
 */
export function fillStringTemplate(
  template: string,
  vars: Record<string, string | number>,
): string {
  let s = template;
  for (const [key, value] of Object.entries(vars)) {
    s = s.split(`{${key}}`).join(String(value));
  }
  return s;
}
